import { create } from 'zustand';
/**
 * 썸네일 이미지 포함한 전역적인 플레이어를 상태관리합니다.
 * @param set
 */
var player = create(function (set) { return ({
    // player
    tvingPlayer: null,
    setTvingPlayer: function (tvingPlayer) {
        set(function () { return ({ tvingPlayer: tvingPlayer }); });
    },
}); });
export var usePlayerStore = player;
